export const environmentData = {
  run: "development",
  development: {
    clientId: "62981dd1-8238-412b-a0a4-0c4a4bccd2bb",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 62981dd1-8238-412b-a0a4-0c4a4bccd2bb/user_scope1",

    apiBaseURL: "https://hm-hudson-dashboard.azurewebsites.net/api",
  },
  staging: {
    clientId: "62981dd1-8238-412b-a0a4-0c4a4bccd2bb",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 62981dd1-8238-412b-a0a4-0c4a4bccd2bb/user_scope1",

    apiBaseURL: "https://hm-hudson-dashboard.azurewebsites.net/api",
  },
  production: {
    clientId: "62981dd1-8238-412b-a0a4-0c4a4bccd2bb",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 62981dd1-8238-412b-a0a4-0c4a4bccd2bb/user_scope1",
    apiBaseURL: "https://hm-hudson-dashboard.azurewebsites.net/api",
  },
};
